import { changeCollectionConfirmed } from '@wix/bi-logger-wix-code-data/v2'
import openErrorPanel from '@wix/wix-data-client-common/dist/esm/panels/error-panel/openErrorPanel'
import { getAssetUrlInWorker } from '@wix/wix-data-client-common/dist/esm/panels/getAssetUrl'
import { changeCollectionPanel } from '@wix/wix-data-client-common/dist/esm/bi/panelDataForBi'
const { panelName } = changeCollectionPanel

export default async (
  { editorSdkProxy, i18n, logger },
  { controllerRef, newCollection, isPreviousCollectionHidden },
) => {
  const [pageRef, controller, illustration] = await Promise.all([
    editorSdkProxy.components.getPage({
      componentRef: controllerRef,
    }),
    editorSdkProxy.controllers.getData({
      controllerRef,
    }),
    getAssetUrlInWorker(
      editorSdkProxy,
      'panel-icons/disconnect_dynamic_page.svg',
    ),
  ])
  let panelCloseValue = false

  const closePanelWithBI = (closeValue, category) => {
    panelCloseValue = closeValue

    logger.bi(
      changeCollectionConfirmed({
        collection_name: closeValue ? newCollection.displayName : '',
        collection_id: closeValue ? newCollection.id : '',
        category,
        pageId: pageRef.id,
        panel_name: panelName,
        ds_id: controllerRef.id,
        ds_name: controller.displayName,
      }),
    )
  }

  const content = isPreviousCollectionHidden
    ? {
        headerText: i18n.t(
          'Workspace_Dataset_Settings_Connect_Hidden_Wix_App_Collection_Change_Title',
        ),
        topDescriptionText: i18n.t(
          'Workspace_Dataset_Settings_Connect_Hidden_Wix_App_Collection_Change_Paragraph_1',
        ),
        bottomDescriptionText: i18n.t(
          'Workspace_Dataset_Settings_Connect_Hidden_Wix_App_Collection_Change_Paragraph_2',
        ),
        mainActionText: i18n.t(
          'Workspace_Dataset_Settings_Connect_Hidden_Wix_App_Collection_Change_Primary_CTA',
        ),
        secondaryActionText: i18n.t(
          'Workspace_Dataset_Settings_Connect_Hidden_Wix_App_Collection_Change_Secondary_CTA',
        ),
      }
    : {
        headerText: i18n.t('WORKSPACE_NOTE_COLLECTION_CHANGE_TITLE'),
        topDescriptionText: `<p>${i18n.t('Workspace_Note_Collection_Change_Text')}</p><ol><li>${i18n.t('Workspace_Note_Collection_Change_Bullet1')}</li><li>${i18n.t('Workspace_Note_Collection_Change_Bullet2')}</li></ol><p>${i18n.t('Workspace_Note_Collection_Change_Question')}</p>`,
        mainActionText: i18n.t('Workspace_Note_Collection_Change_Button2'),
        secondaryActionText: i18n.t('Workspace_Note_Collection_Change_Button1'),
        shouldShowIllustration: true,
      }

  await openErrorPanel({
    editorSdkProxy,
    logger,
    illustration,
    ...content,
    onMainActionClick: () => closePanelWithBI(true, 'continue'),
    onSecondaryActionClick: () => closePanelWithBI(false, 'cancel'),
    onCloseClick: () => closePanelWithBI(false, 'close'),
  })

  return panelCloseValue
}
